import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Paper, withStyles } from '@material-ui/core';
import OldSecurazeData from './OldSecurazeData';
import * as actions from './store/oldSecurazeDataActions.js';
import * as pcProductActions from '../../sc-product/PCProduct/store/pcProductActions';
import { hasPermission } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});



const IndexOldSecurazeData = props => {
    const { classes, fetchOrders, fetchCollies, activeCustomer, translations, permissions } = props;
    const [changePaletteModalState, setChangePaletteModalState] = useState({ orders: [] });

    const isMounted = React.useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let orderData = await fetchOrders({ ActiveCustomerID: activeCustomer });
            let collies = await fetchCollies({ ActiveCustomerID: activeCustomer });
            if (isMounted.current) {
                setChangePaletteModalState({ orders: orderData, Collies: collies });
            }
        }
        fetchData();
    }, [fetchOrders, fetchCollies, activeCustomer]);



    return (
        <div className={classes.root}>
            {hasPermission(permissions, '*') ? <>
                <Paper className={classes.root}>
                    <OldSecurazeData translations={translations} activeCustomer={activeCustomer} changePaletteState={changePaletteModalState} importData={props.importData} />
                </Paper>
            </> : null}

        </div>
    );
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        importData: data => dispatch(actions.importData(data)),
        fetchOrders: (id) => dispatch(pcProductActions.fetchOrders(id)),
        fetchCollies: (id) => dispatch(pcProductActions.fetchCollies(id))
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(IndexOldSecurazeData));